import { useEffect, useState } from 'react';

export type ParentStyles = {
  paddingRight?: string;
  marginRight?: string;
  paddingLeft?: string;
  marginLeft?: string;
}[];

export function useParentDivLayoutStyles(elementRef: React.RefObject<HTMLElement | null>) {
  const [parentStyles, setParentStyles] = useState<ParentStyles>([]);

  useEffect(() => {
    if (!elementRef.current) return;

    const getParentDivLayoutStyles = (element: HTMLElement | null) => {
      const styles = [];
      let currentElement = element;

      while (currentElement && currentElement !== document.body) {
        currentElement = currentElement.parentElement;

        if (currentElement && currentElement.tagName.toLowerCase() === 'div') {
          const computedStyle = window.getComputedStyle(currentElement);
          styles.push({
            paddingRight: computedStyle.paddingRight,
            marginRight: computedStyle.marginRight,
            paddingLeft: computedStyle.paddingLeft,
            marginLeft: computedStyle.marginLeft,
          });
        }
      }

      return styles;
    };

    const styles = getParentDivLayoutStyles(elementRef.current);
    setParentStyles(styles);
  }, [elementRef]);

  return parentStyles;
}
